import { useCallback, useEffect } from 'react';

import { ServiceMode } from 'generated/graphql-gateway';

interface UseRepriceOnServiceModeMismatchProps {
  serviceMode: ServiceMode;
  serverOrderServiceMode?: ServiceMode;
  tryPricing: () => void;
  isOrderPriceLoading: boolean;
  onError?: (error: Error) => void;
}

export const useRepriceOnServiceModeMismatch = ({
  serviceMode,
  serverOrderServiceMode,
  tryPricing,
  isOrderPriceLoading,
  onError,
}: UseRepriceOnServiceModeMismatchProps) => {
  const handleRepricing = useCallback(() => {
    try {
      tryPricing();
    } catch (error) {
      onError?.(error as Error);
    }
  }, [tryPricing, onError]);

  useEffect(() => {
    if (!serverOrderServiceMode || isOrderPriceLoading) {
      return;
    }

    if (serverOrderServiceMode !== serviceMode) {
      const timer = setTimeout(() => {
        handleRepricing();
      }, 0);
      return () => clearTimeout(timer);
    }
  }, [serviceMode, handleRepricing, serverOrderServiceMode, isOrderPriceLoading]);
};
